import VerifyList from '@/views/webpc/CreditMall/VerifyListApp/VerifyList'

// 定义路由路径数列表
export default [{
  path: '/verifyList',
  name: '核销记录 ',
  component: VerifyList
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CreditMall/VerifyListApp/routers/index.js